import { Component } from '@theme/component';

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Header do protótipo: abre/fecha o drawer do menu e mantém --header-height/--header-group-height
 * (o Horizon só calcula com o header dele, que foi substituído).
 * @extends {Component<{menu: HTMLDialogElement}>}
 */
class CharmHeader extends Component {
  requiredRefs = ['menu'];

  #observer = new ResizeObserver(() => this.#measure());

  connectedCallback() {
    super.connectedCallback();
    this.#observer.observe(this);
    this.#measure();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer.disconnect();
  }

  openMenu() {
    this.refs.menu.showModal();
  }

  closeMenu() {
    this.refs.menu.close();
  }

  /**
   * Clique no fundo escuro fecha. O dispatcher do Horizon troca event.target pelo elemento do on:click (o próprio
   * <dialog>), então o alvo real vem de composedPath().
   * @param {MouseEvent} event
   */
  closeOnBackdrop(event) {
    if (event.composedPath()[0] === this.refs.menu) this.closeMenu();
  }

  #measure() {
    const height = Math.round(this.offsetHeight);
    const group = document.querySelector('#header-group');
    let groupHeight = 0;
    group?.querySelectorAll(':scope > .shopify-section').forEach((s) => (groupHeight += s.offsetHeight));
    document.body.style.setProperty('--header-height', `${height}px`);
    document.body.style.setProperty('--header-group-height', `${groupHeight || height}px`);
  }
}

/**
 * Anúncio mobile: uma mensagem por vez, com fade (protótipo: 3,8 s). Sem rotação com movimento reduzido.
 * @extends {Component<{messages: HTMLElement[]}>}
 */
class CharmAnnouncement extends Component {
  #index = 0;
  #timer = 0;

  connectedCallback() {
    super.connectedCallback();
    const messages = this.refs.messages ?? [];
    if (messages.length < 2 || reducedMotion()) return;
    this.#timer = window.setInterval(() => this.#next(), Number(this.dataset.interval) || 3800);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearInterval(this.#timer);
  }

  #next() {
    const messages = this.refs.messages;
    const current = messages[this.#index];
    current.classList.add('is-fading');
    window.setTimeout(() => {
      current.hidden = true;
      current.classList.remove('is-fading');
      this.#index = (this.#index + 1) % messages.length;
      messages[this.#index].hidden = false;
    }, 400);
  }
}

if (!customElements.get('charm-header-component')) customElements.define('charm-header-component', CharmHeader);
if (!customElements.get('charm-announcement-component')) {
  customElements.define('charm-announcement-component', CharmAnnouncement);
}
